import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Grid } from "@mui/material";
import api from "../../../../helpers/api/Api";
import ApiUrls from "../../../../helpers/urls/ApiUrls";
import AppConfig from "../../../../helpers/constants/AppConfig";
import AddDomain from "../add";
import LoadingProgress from "../../../../components/LoadingProgress";
import MDBox from "../../../../components/MDs/MDBox";
import DashboardLayout from "../../../../components/LayoutContainers/DashboardLayout";

function EditDomain() {
  let [searchParams] = useSearchParams();
  const [formData, setFormData] = useState();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const id = searchParams.get("id");
    if (id) {
      getDomain(id);
    }
  }, [searchParams]);

  const getDomain = (id) => {
    setLoading(true);

    const fd = new FormData();
    fd.append("uid", id);

    api.post(ApiUrls.domain.list, fd)
      .then((response) => {
        createFormData(response.data.data[0]);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  }

  const createFormData = (data) => {
    const domainArr = data.name.split(" ");
    const filteredDomain = domainArr.filter((d) => d !== "");
    setFormData({
      ...data,
      domain: filteredDomain
    });
  }

  return (
    <>
      {formData &&
        <AddDomain
          isEdit
          data={formData}
        />
      }

      {loading &&
         <DashboardLayout>
           <MDBox pt={4} pb={3}>
             <Grid container spacing={6}>
               <Grid item xs={12}>
                 <LoadingProgress color={AppConfig.color} />
               </Grid>
             </Grid>
           </MDBox>
         </DashboardLayout>
      }
    </>
  );
}

export default EditDomain;
